<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :left-side-class="'col-xl-8'"
      :right-side-class="'col-xl-4 align-items-end d-flex pb-2 justify-content-end'"
    >
      <template v-slot:customActions>
        <ActionButton
          variant="success m-1"
          text="Añadir"
          i="fas fa-file-plus"
          :responsive="false"
          @click="gotToCreate"
        />

        <ActionButton
          v-if="canGenerateParams"
          variant="success m-1"
          text="Generar Parámetro"
          i="fas fa-layer-plus"
          :responsive="false"
          @click="generateParams"
        />
      </template>
    </page-header>
    <filter-manager
      ref="filter"
      v-model="this.filters"
      :display-advanced="false"
      items-container-class="flex-wrap"
      actions-container-class="col-sm-3 ml-0 mr-0 text-right"
      :filters="filtersHeader"
      :search-text="Buscar"
      @search="onSearch"
    />
    <CustomSeparator
      text="Resultado de Parámetros"
      class="mt-4 custom-separator-line"
    />
    <CustomResultNotFound
      v-if="results.length == 0"
      class="mt-4 row pt-3"
      :text="noResultsText"
    />
    <div class="row pt-2">
      <div v-if="results.length > 0" class="col-12">
        <ResultRow
          v-for="(item, index) in results"
          :key="`row-item-${index}`"
          :item="item"
        />
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-12 pt-0">
        <pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          @pagination-go-page="onPagedChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import CustomSeparator from "custom-separator";
import ActionButton from "ActionButton";
import FilterManager from "FilterManager";
import {
  getAcademicYears,
  getPagedData,
} from "@/modules/system-parameter-managment/api.js";
import mixWait from "@/mixin/loading.mixin";
import mixAlert from "@/mixin/alert.mixin";
import ResultRow from "./components/ResultRow";
import storeMixin from "@/mixin/storeGenerator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
import { generateParametersAndConfForFutureYear } from "@/modules/system-parameter-managment/api";

const EDIT_SYS_PARAM_ROUTE_NAME = "createEditSystemParameter";

export default {
  name: "SystemParameterManagementMain",
  mixins: [mixAlert, mixWait, storeMixin],
  components: {
    PageHeader,
    CustomSeparator,
    ActionButton,
    FilterManager,
    ResultRow,
    CustomResultNotFound,
    Pagination,
  },
  data() {
    return {
      moduleName: "systemParameterModule",
      noResultsText: "No se ha encontrado resultado de parámetro de sistemas.",
      page: {
        icon: "fas fa-calculator",
        title: "Manejo de Parámetros de Sistema",
        routes: ["Inicio", "Operaciones", "Manejo de Parámetros de Sistema"],
      },
      results: [],
      messages: [],
      collections: {
        academicYears: [],
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      filters: {
        academicYear: null,
        searchText: null,
      },
      tableConfig: {
        totalRecords: 0,
        perPage: 10,
      },
    };
  },
  computed: {
    filtersHeader() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          placeholder: "Seleccione el año",
          fieldName: "description",
          fieldKey: "id",
          clearable: true,
          class: "col-sm-6 col-md-6 col-lg-3 ml-0 mr-0",
          classContainer: "w-100",
          mapParentValue: this.filters.academicYear == null,
        },
        {
          name: "searchText",
          component: "CustomInput",
          placeholder: "Nombre o descripción de Parámetro de Sistema",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          type: "text",
          class: "col-sm-6 col-md-6 col-lg-9 ml-0 mr-0",
        },
      ];
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    canGenerateParams() {
      return this.$store.getters.HasPermission(
        "operation.sysparams.generatefutureparameters"
      );
    },
  },
  methods: {
    async generateParams() {
      await generateParametersAndConfForFutureYear();
      this.ShowToast("Proceso Exitoso.", "", "success");
    },
    async onSearch(page) {
      getPagedData(
        this.filters.academicYear != null ? this.filters.academicYear.id : null,
        this.filters.searchText ?? "",
        this.tableConfig.perPage,
        page ?? 1
      )
        .then((res) => {
          this.results = res.data.data;
          this.tableConfig.totalRecords = res.data.totalItemCount;
          this.pagination = {
            ...this.pagination,
            totalItemCount: res.data.totalItemCount,
            pageCount: res.data.pageCount,
            currentPage: res.data.currentPage,
            count: res.data.count,
          };
        })
        .catch((errm) => {
          this.ShowToast(errm.message, "", "error");
        });
    },
    loadAcademicYears() {
      getAcademicYears()
        .then((response) => {
          if (response.data.length > 0) {
            this.collections.academicYears = response.data;
            this.filters.academicYear = response.data[0];
          }
        })
        .catch((errm) => {
          this.ShowToast(errm.message, "", "error");
        });
    },
    gotToCreate() {
      this.$router.push({ name: EDIT_SYS_PARAM_ROUTE_NAME });
    },
    loadSystemParams() {
      getPagedData("", "", 10, 1)
        .then((res) => {
          if (res.data.count > 0) {
            this.results = res.data.data;

            this.pagination = {
              ...this.pagination,
              totalItemCount: res.data.totalItemCount,
              pageCount: res.data.pageCount,
              currentPage: res.data.currentPage,
              count: res.data.count,
            };
          }
        })
        .catch((errm) => {
          this.ShowToast(errm.message, "", "error");
        });
    },
    onPagedChanged(currentPage) {
      this.onSearch(currentPage);
    },
  },
  async mounted() {
    if (this.collections.academicYears.length == 0) {
      this.loadAcademicYears();
      this.loadSystemParams();
    }
  },
  destroyed() {
    this.persistData();
  },
};
</script>

<style scoped>
.search {
  height: 36px;
}

@media only screen and (max-width: 375px) {
  ::v-deep .separator-custom {
    font-size: 12px !important;
  }

  ::v-deep .separator-custom__text {
    font-weight: normal;
    padding: 2px 16px !important;
  }

  ::v-deep .vs__search {
    font-size: 12px !important;
  }

  ::v-deep .vs__selected {
    font-size: 12px !important;
  }

  ::v-deep .vs__dropdown-menu {
    font-size: 12px !important;
  }

  ::v-deep .leftInput {
    font-size: 12px !important;
  }
}
</style>
